export class MPARequestPolicyDetail {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaPolicyId",
            "baseName": "mpaPolicyId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "requiredApprovals",
            "baseName": "requiredApprovals",
            "type": "number",
            "format": ""
        },
        {
            "name": "currentApprovals",
            "baseName": "currentApprovals",
            "type": "number",
            "format": ""
        },
        {
            "name": "executionWindowHours",
            "baseName": "executionWindowHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "approvalWindowHours",
            "baseName": "approvalWindowHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "approverIdpGroupId",
            "baseName": "approverIdpGroupId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "approverIdpGroupName",
            "baseName": "approverIdpGroupName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPARequestPolicyDetail.attributeTypeMap;
    }
    constructor() {
    }
}
